import { render, staticRenderFns } from "./GeneralSearch.vue?vue&type=template&id=4a2fa7fc&scoped=true"
import script from "./GeneralSearch.vue?vue&type=script&lang=js"
export * from "./GeneralSearch.vue?vue&type=script&lang=js"
import style0 from "./GeneralSearch.vue?vue&type=style&index=0&id=4a2fa7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2fa7fc",
  null
  
)

export default component.exports